module.exports = __webpack_public_path__ + "static/media/3.b567a0f9.png";